import { render } from "./CodemirrorEditor.vue?vue&type=template&id=fa679186"
import script from "./CodemirrorEditor.vue?vue&type=script&lang=js"
export * from "./CodemirrorEditor.vue?vue&type=script&lang=js"

import exportComponent from "/mudfix/license/ui-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__